import { render } from "./MezzoDettaglio.vue?vue&type=template&id=cdc2e52e"
import script from "./MezzoDettaglio.vue?vue&type=script&lang=js"
export * from "./MezzoDettaglio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__